import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GeneratorInputComponent } from './generator-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { AddressSuggestPluginModule } from '../address-suggest-plugin/address-suggest-plugin.module';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { PipesModule } from '../../../pipes/pipes.module';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TooltipModule } from 'primeng/tooltip';
import { MapModule, SanitizePipeModule } from '@digistore/ds24-ui/pipes';

@NgModule({
  declarations: [GeneratorInputComponent],
  exports: [GeneratorInputComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AddressSuggestPluginModule,
    CalendarModule,
    DropdownModule,
    PipesModule,
    SanitizePipeModule,
    OverlayPanelModule,
    TooltipModule,
    MapModule,
  ],
  providers: [],
})
export class GeneratorInputModule {}
